// =====================================================
// REPORTE "PLAN PRODUCTIVO" (BDSJEA-466): formato y vocabulario compartidos
// src/pages/Agro/Productor/reportePlanProductivoComun.js
// Un solo lugar para lo que usan el modal y la exportación a Excel, así pantalla y Excel no se desalinean.
// =====================================================

import { formatearNumero } from "helpers/formatters"

export const ND = "no disponible"
export const NA = "—"

export const MAQUINARIA = {
  SI: "Sí",
  NO: "No",
  PARCIAL: "Parcial",
  SIN_DATOS: "sin datos",
}

export const destinoDe = f =>
  f.improductivo ? "Campos improductivos" : f.destino

// BDSJEA-468: las has de ganadería / tambo que el plan productivo declara sin ubicación propia (lotes derivados por el migrador) no tienen id de origen.
export const ETIQUETA_PLAN_PRODUCTIVO =
  "has del plan productivo, sin ubicación propia"

// Columna «Id» del Resumen de Establecimientos: el id de origen, o el rótulo de las has del plan productivo sin ubicación propia, o «-».
// Pantalla, impresión y Excel usan ESTE helper (antes el Excel no mostraba el rótulo que la pantalla sí).
export const idOrigenDe = f =>
  f.idOrigen ?? (f.origenPlanProductivo ? ETIQUETA_PLAN_PRODUCTIVO : "-")

// BDSJEA-470: columna «Zona» del Resumen de Establecimientos = nivel de rendimiento del establecimiento («Rinde Muy Bueno»…; catálogo
// general Nivel de Rendimiento), NO la zona agro del departamento. «-» si el establecimiento no tiene nivel.
export const nivelRendimientoDe = f => f.nivelRendimiento || "-"

// BDSJEA-515: columna «Rendimiento» de la tabla de agricultura = niveles de rendimiento distintos de las siembras del cultivo (etiquetas del catálogo,
// en orden de código) separados por «, »; «-» si ninguna siembra tiene nivel o si el backend es anterior y no manda el campo. Pantalla, impresión y Excel usan ESTE helper.
export const nivelesRendimientoDe = c =>
  (Array.isArray(c?.nivelesRendimiento) ? c.nivelesRendimiento : []).join(", ") ||
  "-"

// BDSJEA-519: texto de la nota «¿Cómo se calcula el rendimiento?» del reporte. Fiel a docs/valores-por-zona-agro.md (sección 5, cadena de
// rendimiento); el título de la nota lo pone la pantalla.
export const TEXTO_COMO_SE_CALCULA_RENDIMIENTO =
  "Se toma la primera fuente que tenga dato, en este orden: el rendimiento declarado en la siembra por una persona, el rendimiento real de la campaña anterior, el promedio de las últimas campañas de la serie oficial del MAGyP para el departamento del establecimiento (si el departamento no tiene datos, el total de la provincia), el valor de referencia que el banco carga para la zona en Administración > Valores Agro y, como último recurso, el valor por defecto configurado (30 qq/ha). Si no hay ningún dato, se muestra «-»."

// Decimales que muestra la pantalla para hectáreas/cantidades: 2 solo si hay fracción (misma regla que la grilla de Establecimientos)
export const decimalesHa = v =>
  v != null && Math.abs(v - Math.round(v)) >= 0.005 ? 2 : 0

export const ha = v => formatearNumero(v, decimalesHa(v))

// Valor que puede no existir en Ewan (NULL): «—», nunca un 0 inventado
export const haONa = v => (v == null ? NA : ha(v))

/**
 * BDSJEA-507: cabezas de bovino comercializadas por año del reporte, con la campaña si viene
 * («13.500 (campaña 2026/27)»); null si el productor no tiene el dato (la pantalla dice ND).
 */
export const comercializadasTexto = r => {
  if (r == null || r.cabezasComercializadasAnio == null) return null
  const n = formatearNumero(r.cabezasComercializadasAnio, 0)
  return r.cabezasComercializadasCampana
    ? `${n} (campaña ${r.cabezasComercializadasCampana})`
    : n
}

export const pct = v => (v == null ? "-" : `${formatearNumero(v, 0)} %`)
